import { HH } from "../../../Constants/modelTypes";
import { formatStringAsCurrency } from "../../../Utils/stringUtils";
import { ResultValue } from "../../Simple";

export default function PaymentComponents(props) {
    if (props.model === HH) {
        return (<>
            <h4>Payment Components</h4>
            <ResultValue label="LUPA" value={formatStringAsCurrency(props.result.lupaRate)} />
            <ResultValue label="Non-LUPA" value={formatStringAsCurrency(props.result.nonLUPARate)} />
            <ResultValue label="High-Cost Outlier" value={formatStringAsCurrency(props.result.highCostOutlier)} />
            {props.calendarYear >= 2020 && <ResultValue label="Late RAP Penalty" value={formatStringAsCurrency(props.result.lateRAPPenalty, false)} />}
        </>);
    }

    console.warn('Model unknown:', props.model);
    return null;
}